var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor"},[_c('Label',{attrs:{"data":{ value: _vm.value, tag: 'div', size: 'label-xs' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }